<template>
  <section class="choose-box-modal">
    <div class="contentContainer">
      <div class="closeMessageModalWrapper">
        <close-icon :isSmall="true" @closeEvent="close()"></close-icon>
      </div>
      <div class="choose-box-modal__header add--text-align-center">
        What type of box would you like to create? 👇
      </div>
      <div class="buttonWrap">
        <div class="segment" v-on:click="$emit('box')">
          <div class="segment__text-wrapper">
            <div class="segment__text">CONTENT</div>
          </div>
          <div class="selection__icon-wrapper">
            <div class="segment__icon">
              <svg
                width="60"
                height="60"
                viewBox="0 0 40 38"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4 4H30V18H34V4C34 1.794 32.206 0 30 0H4C1.794 0 0 1.794 0 4V28C0 30.206 1.794 32 4 32H20V28H4V4Z"
                  fill="#48B9BA"
                />
                <path d="M12 16L6 24H28L20 12L14 20L12 16Z" fill="#48B9BA" />
                <path
                  d="M34 22H30V28H24V32H30V38H34V32H40V28H34V22Z"
                  fill="#48B9BA"
                />
              </svg>
            </div>
          </div>
        </div>
        <!-- <div class="segment" v-on:click="$emit('information')">
          <div class="segment__text-wrapper">
            <div class="segment__text">INFORMATION</div>
          </div>
          <div class="selection__icon-wrapper">
            <div class="segment__icon">
              <svg
                width="60"
                height="60"
                viewBox="0 0 24 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M22.8333 39.5H0.5V37.1376C0.672674 37.1212 0.884037 37.0957 1.12387 37.0557C1.78161 36.9461 2.66625 36.7259 3.55694 36.2805C4.44959 35.8342 5.35745 35.1569 6.04103 34.1315C6.72669 33.103 7.16667 31.7542 7.16667 30V23.3333C7.16667 21.5792 6.72669 20.2303 6.04103 19.2018C5.35745 18.1764 4.44959 17.4991 3.55694 17.0528C2.66625 16.6074 1.78161 16.3873 1.12387 16.2776C0.884037 16.2377 0.672674 16.2121 0.5 16.1958V13.8333H13.3333C14.0041 13.8333 14.7166 14.1737 15.2714 14.7286C15.8263 15.2834 16.1667 15.9959 16.1667 16.6667V30C16.1667 31.7542 16.6066 33.103 17.2923 34.1315C17.9759 35.1569 18.8837 35.8342 19.7764 36.2805C20.6671 36.7259 21.5517 36.9461 22.2095 37.0557C22.4493 37.0957 22.6607 37.1212 22.8333 37.1376V39.5ZM7.16667 5C7.16667 2.60948 9.27614 0.5 11.6667 0.5C14.0572 0.5 16.1667 2.60948 16.1667 5C16.1667 7.39052 14.0572 9.5 11.6667 9.5C9.27614 9.5 7.16667 7.39052 7.16667 5Z"
                  fill="#48B9BA"
                />
              </svg>
            </div>
          </div>
        </div> -->
        <!-- <div class="segment" v-on:click="$emit('voucher')">
          <div class="segment__text-wrapper">
            <div class="segment__text">VOUCHER</div>
          </div>
          <div class="selection__icon-wrapper">
            <div class="segment__icon">
              <svg
                width="60"
                height="60"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.16479 23.2787L16.7196 30.8377L30.5867 16.9706L23.0276 9.41584L9.16479 23.2787ZM39.3712 12.9028L36.1565 9.68603C35.34 10.1322 34.4009 10.3018 33.4799 10.1696C32.5589 10.0374 31.7055 9.61047 31.0475 8.95266C30.3894 8.29486 29.9621 7.4416 29.8296 6.52064C29.6971 5.59968 29.8664 4.66057 30.3122 3.84389L27.0976 0.627101C26.6923 0.225388 26.1449 0 25.5743 0C25.0037 0 24.4562 0.225388 24.051 0.627101L0.627101 24.051C0.225388 24.4562 0 25.0037 0 25.5743C0 26.1449 0.225388 26.6923 0.627101 27.0976L3.84389 30.3101C4.66081 29.8628 5.60074 29.6924 6.52269 29.8245C7.44464 29.9566 8.29891 30.3841 8.95736 31.0428C9.61581 31.7015 10.043 32.5559 10.1747 33.4779C10.3065 34.3999 10.1358 35.3397 9.68816 36.1565L12.905 39.369C13.3096 39.7718 13.8573 39.9979 14.4282 39.9979C14.9992 39.9979 15.5469 39.7718 15.9515 39.369L39.3712 15.9494C39.7739 15.5447 40 14.9971 40 14.4261C40 13.8552 39.7739 13.3075 39.3712 12.9028ZM16.7196 34.2949L5.70759 23.2787L23.0298 5.95864L34.0417 16.9706L16.7196 34.2949Z"
                  fill="#48B9BA"
                />
              </svg>
            </div>
          </div>
        </div> -->
        <!-- <div class="segment" v-on:click="$emit('form')">
          <div class="segment__text-wrapper">
            <div class="segment__text">PRODUCTS</div>
          </div>
          <div class="selection__icon-wrapper">
            <div class="segment__icon">
              <svg
                width="60"
                height="60"
                viewBox="0 0 60 61"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M60 13V61.0004H0.959503C0.00549536 61.0004 -0.288507 60.3734 0.311498 59.6054L13.7186 42.3612C13.853 42.181 14.0244 42.0316 14.2212 41.923C14.418 41.8144 14.6358 41.7491 14.8599 41.7315C15.0841 41.7139 15.3094 41.7444 15.5207 41.8209C15.7321 41.8974 15.9247 42.0182 16.0856 42.1752L20.3427 46.1773C20.4962 46.3331 20.6836 46.4514 20.8904 46.5228C21.0971 46.5943 21.3176 46.6169 21.5346 46.589C21.7516 46.5612 21.9592 46.4835 22.1411 46.3621C22.3231 46.2407 22.4746 46.0789 22.5837 45.8893L31.7248 31.6692C31.833 31.4806 31.9837 31.3199 32.1649 31.1998C32.3461 31.0797 32.5528 31.0036 32.7686 30.9773C32.9845 30.9511 33.2034 30.9756 33.4081 31.0488C33.6128 31.1221 33.7976 31.242 33.9478 31.3992L40.4608 37.6872C41.1568 38.3622 42.1379 38.2272 42.6329 37.3872L58.032 14.032C58.53 13.186 59.25 13 60 13Z"
                  fill="#48B9BA"
                />
                <path
                  d="M35.5 8.125H38C38 4.57875 34.5562 2.96125 31.75 2.58875V0H29.25V2.58875C26.4437 2.96125 23 4.57875 23 8.125C23 11.5075 26.3325 13.2663 29.25 13.6625V19.875C27.44 19.5612 25.5 18.595 25.5 16.875H23C23 20.1112 26.0312 22.0238 29.25 22.42V25H31.75V22.4125C34.5562 22.04 38 20.4212 38 16.875C38 13.3288 34.5562 11.7112 31.75 11.3387V5.125C33.4125 5.42375 35.5 6.30125 35.5 8.125ZM25.5 8.125C25.5 6.30125 27.5875 5.42375 29.25 5.125V11.1238C27.5362 10.8075 25.5 9.87125 25.5 8.125ZM35.5 16.875C35.5 18.6987 33.4125 19.5762 31.75 19.875V13.875C33.4125 14.1737 35.5 15.0513 35.5 16.875Z"
                  fill="#48B9BA"
                />
              </svg>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </section>
</template>

<script>
import CloseIcon from "@/components/GlobalComponents/CloseIcon";

export default {
  components: {
    CloseIcon,
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.contentContainer {
  position: absolute;
  background: linear-gradient(360deg, #fff 50%, #48b9ba 50%);
  height: 300px;
  border-radius: 5px;
  padding-left: 30px;
  padding-right: 30px;
}

.segment {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-content: space-between;
  height: 180px;
  width: 175px;
  margin-left: 15px;
  margin-right: 15px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.25);
}

.segment__text-wrapper {
  font-size: 20px;
  display: flex;
  align-items: center;
  height: 60px;
  align-items: flex-end;
}

.segment__text {
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  align-items: flex-end;
  line-height: 20px;
  color: #48b9ba;
}

.selection__icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  height: 120px;
}

.selection__icon {
  align-items: center;
  width: 100%;
}

.choose-box-modal {
  background-color: rgba(0, 0, 0, 0.8);
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.choose-box-modal__header {
  color: #fff;
  font-size: 25px;
  padding: 25px;
}

.buttonWrap {
  display: flex;
  justify-content: center;
  width: 100%;
}

.closeMessageModalWrapper {
  position: absolute;
  top: -20px;
  right: 0px;
}
</style>
